/**
 * 1L2C REST API
 * Specification of REST API for 1Life2Connect Project
 *
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type OtpAuthenticatorStatus = 'pending' | 'verified' | 'invalidated';

export const OtpAuthenticatorStatus = {
    Pending: 'pending' as OtpAuthenticatorStatus,
    Verified: 'verified' as OtpAuthenticatorStatus,
    Invalidated: 'invalidated' as OtpAuthenticatorStatus
};